import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDisplayCampaignComponent, SharedDisplayModule } from '@brightside-web/shared/display';
import { MySpendingInfoViewComponent } from './my-spending-info-view/my-spending-info-view.component';
import { MySpendingInfoViewGuard } from './my-spending-info-view.guard';

const ROUTES: Routes = [
  {
    path: 'info-view',
    component: MySpendingInfoViewComponent,
    canActivate: [MySpendingInfoViewGuard]
  },
  { path: '**', redirectTo: 'info-view' },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    BrightsideUiModule,
    TranslateModule,
    SharedDisplayModule,
  ],
  declarations: [MySpendingInfoViewComponent],
  providers: [MySpendingInfoViewGuard],
})
export class MySpendingModule {}
